import styled from 'styled-components';
import { Container } from '../../../layout/Container';

export const InterviewContainer = styled(Container)`
  max-width: 80rem;
`;
